import { c as _c } from "react/compiler-runtime";
import { Button } from "@website/ui/button";
import { Loading } from "@website/ui/loading";
import { Header } from "@website/widget/login/components";
import { useNewPasswordCard } from "@website/widget/login/components/new-password-card/new-password-card.hook";
import styles from "@website/widget/login/components/new-password-card/new-password-card.module.scss";
import { NewPasswordCardPropertiesType } from "@website/widget/login/components/new-password-card/new-password-card.types";
import { PasswordField } from "@website/widget/password-field";
import { FC } from "react";
export const NewPasswordCard: FC<NewPasswordCardPropertiesType> = properties => {
  const $ = _c(20);
  const {
    error,
    password,
    onChangePassword,
    onSubmitPassword,
    isLoading,
    onCloseClick,
    onBackClick
  } = useNewPasswordCard(properties);
  let t0;
  if ($[0] !== onBackClick || $[1] !== onCloseClick) {
    t0 = <Header onBack={onBackClick} onClose={onCloseClick} title={"\u0631\u0645\u0632 \u0639\u0628\u0648\u0631 \u062C\u062F\u06CC\u062F"} />;
    $[0] = onBackClick;
    $[1] = onCloseClick;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const t1 = isLoading ? undefined : onSubmitPassword;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className={styles.title}>لطفاً یک رمز عبور جدید وارد کنید.</div>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = Boolean(error);
  let t4;
  if ($[4] !== error || $[5] !== onChangePassword || $[6] !== password || $[7] !== t3) {
    t4 = <div className={styles.input}><PasswordField error={t3} fullWidth={true} helperText={error} initialValue={password} onChange={onChangePassword} placeholder={"\u0631\u0645\u0632 \u0639\u0628\u0648\u0631 \u062C\u062F\u06CC\u062F"} /></div>;
    $[4] = error;
    $[5] = onChangePassword;
    $[6] = password;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== isLoading) {
    t5 = isLoading ? <Loading color="white" size="lg" /> : "\u062A\u0627\u06CC\u06CC\u062F \u0648 \u0627\u062F\u0627\u0645\u0647";
    $[9] = isLoading;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <div className={styles.footer}><Button color="secondary" fullWidth={true} size="large" type="submit" variant="contained">{t5}</Button></div>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t1 || $[14] !== t4 || $[15] !== t6) {
    t7 = <form className="w-full" onSubmit={t1}>{t2}{t4}{t6}</form>;
    $[13] = t1;
    $[14] = t4;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t0 || $[18] !== t7) {
    t8 = <div className={styles.container}>{t0}{t7}</div>;
    $[17] = t0;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
};